export const Fonts = `
//fix when spex are ready
// Variables-hel
//
// Helsinki-specific fonts, color variables and defaults.

@charset "utf-8";

// Import Helsinki font files here. For licencing reasons font files are not publicly shared.
@font-face {
  font-family: 'HelsinkiGrotesk';
  font-display: swap;
  src: url('https://makasiini.hel.ninja/delivery/HelsinkiGrotesk/565d73a693abe0776c801607ac28f0bf.woff')
    format('woff');
  font-weight: 400;
  font-style: normal;
  text-rendering: optimizeLegibility;
}
@font-face {
  font-family: 'HelsinkiGrotesk';
  font-display: swap;
  src: url('https://makasiini.hel.ninja/delivery/HelsinkiGrotesk/5bb29e3b7b1d3ef30121229bbe67c3e1.woff')
    format('woff');
  font-weight: 400;
  font-style: italic;
  text-rendering: optimizeLegibility;
}

@font-face {
  font-family: 'HelsinkiGrotesk';
  font-display: swap;
  src: url('https://makasiini.hel.ninja/delivery/HelsinkiGrotesk/7c46f288e8133b87e6b12b45dac71865.woff')
    format('woff');
  font-weight: 500;
  font-style: normal;
  text-rendering: optimizeLegibility;
}

@font-face {
  font-family: 'HelsinkiGrotesk';
  font-display: swap;
  src: url('https://makasiini.hel.ninja/delivery/HelsinkiGrotesk/e62dc97e83a385e4d8cdc939cf1e4213.woff')
    format('woff');
  font-weight: 500;
  font-style: italic;
  text-rendering: optimizeLegibility;
}

@font-face {
  font-family: 'HelsinkiGrotesk';
  font-display: swap;
  src: url('https://makasiini.hel.ninja/delivery/HelsinkiGrotesk/533af26cf28d7660f24c2884d3c27eac.woff')
    format('woff');
  font-weight: 700;
  font-style: normal;
  text-rendering: optimizeLegibility;
}
@font-face {
  font-family: 'HelsinkiGrotesk';
  font-display: swap;
  src: url('https://makasiini.hel.ninja/delivery/HelsinkiGrotesk/20d494430c87e15e194932b729d48270.woff')
    format('woff');
  font-weight: 700;
  font-style: italic;
  text-rendering: optimizeLegibility;
}

@font-face {
  font-family: 'HelsinkiGrotesk';
  font-display: swap;
  src: url('https://makasiini.hel.ninja/delivery/HelsinkiGrotesk/a50a1bd245ce63abcc0d1da80ff790d2.woff')
    format('woff');
  font-weight: 900;
  font-style: normal;
  text-rendering: optimizeLegibility;
}
@font-face {
  font-family: 'HelsinkiGrotesk';
  font-display: swap;
  src: url('https://makasiini.hel.ninja/delivery/HelsinkiGrotesk/62a1781d8b396fbb025b0552cf6304d2.woff')
    format('woff');
  font-weight: 900;
  font-style: italic;
  text-rendering: optimizeLegibility;
}

/*
 * HelsinkiGroteskPro variable font (font file served from CDN).
 * Regular (400), Medium (500), Bold (700), Black (900), each normal and italic.
 * Font axes (fvar): wght 200–900, ital 0–1.
 */
@font-face {
  font-display: swap;
  font-family: HelsinkiGroteskPro;
  font-style: normal;
  font-weight: 400;
  src: url('https://makasiini.hel.fi/delivery/917fc4ffc37c44d31b143244042e0078/9a677fe2c4414b1a40990971cd4ac24c.woff2')
    format('woff2');
  text-rendering: optimizeLegibility;
}
@font-face {
  font-display: swap;
  font-family: HelsinkiGroteskPro;
  font-style: italic;
  font-weight: 400;
  src: url('https://makasiini.hel.fi/delivery/917fc4ffc37c44d31b143244042e0078/9a677fe2c4414b1a40990971cd4ac24c.woff2')
    format('woff2');
  text-rendering: optimizeLegibility;
}
@font-face {
  font-display: swap;
  font-family: HelsinkiGroteskPro;
  font-style: normal;
  font-weight: 500;
  src: url('https://makasiini.hel.fi/delivery/917fc4ffc37c44d31b143244042e0078/9a677fe2c4414b1a40990971cd4ac24c.woff2')
    format('woff2');
  text-rendering: optimizeLegibility;
}
@font-face {
  font-display: swap;
  font-family: HelsinkiGroteskPro;
  font-style: italic;
  font-weight: 500;
  src: url('https://makasiini.hel.fi/delivery/917fc4ffc37c44d31b143244042e0078/9a677fe2c4414b1a40990971cd4ac24c.woff2')
    format('woff2');
  text-rendering: optimizeLegibility;
}
@font-face {
  font-display: swap;
  font-family: HelsinkiGroteskPro;
  font-style: normal;
  font-weight: 700;
  src: url('https://makasiini.hel.fi/delivery/917fc4ffc37c44d31b143244042e0078/9a677fe2c4414b1a40990971cd4ac24c.woff2')
    format('woff2');
  text-rendering: optimizeLegibility;
}
@font-face {
  font-display: swap;
  font-family: HelsinkiGroteskPro;
  font-style: italic;
  font-weight: 700;
  src: url('https://makasiini.hel.fi/delivery/917fc4ffc37c44d31b143244042e0078/9a677fe2c4414b1a40990971cd4ac24c.woff2')
    format('woff2');
  text-rendering: optimizeLegibility;
}
@font-face {
  font-display: swap;
  font-family: HelsinkiGroteskPro;
  font-style: normal;
  font-weight: 900;
  src: url('https://makasiini.hel.fi/delivery/917fc4ffc37c44d31b143244042e0078/9a677fe2c4414b1a40990971cd4ac24c.woff2')
    format('woff2');
  text-rendering: optimizeLegibility;
}
@font-face {
  font-display: swap;
  font-family: HelsinkiGroteskPro;
  font-style: italic;
  font-weight: 900;
  src: url('https://makasiini.hel.fi/delivery/917fc4ffc37c44d31b143244042e0078/9a677fe2c4414b1a40990971cd4ac24c.woff2')
    format('woff2');
  text-rendering: optimizeLegibility;
}
`;
